var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderBy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 4.5V16.5H6L9 19.5L12 16.5H9.75V4.5H8.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.75H18V13.875L14.25 18.75H18V19.5H12.75V18.375L16.5 13.5H12.75V12.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 4.5H17.25L18 5.25V11.25H16.5V9H14.25V11.25H12.75V5.25L13.5 4.5ZM14.25 5.25H16.5V8.25H14.25V5.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderBy);
export default __webpack_public_path__ + "static/media/OrderBy.ae8a67bedd3c96715e7c779206cf9989.svg";
export { ForwardRef as ReactComponent };